// init Swiper:
const techSliderMobile = new Swiper(".c-tech-slider-block__swiper-mobile", {
    loop: true,
    watchSlidesVisibility: true,
    slidesPerView: 1,
    effect: "fade",
    fadeEffect: {
        crossFade: true,
    },

    // If we need pagination
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },

    // Navigation arrows
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

const techSliderFull = new Swiper(".c-tech-slider-block__swiper-desktop", {
    loop: true,
    watchSlidesVisibility: true,
    slidesPerView: 1,
    effect: "fade",
    fadeEffect: {
        crossFade: true,
    },

    // If we need pagination
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },

    // Navigation arrows
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

const postSlides = document.querySelectorAll(".c-news-block__swiper .swiper-slide");
const postsSliderLoop = postSlides.length > 2;
const postsSlider = new Swiper(".c-news-block__swiper", {
    loop: postsSliderLoop,
    watchSlidesVisibility: true,
    effect: "slide",
    slidesPerView: "auto",
    spaceBetween: 24,

    breakpoints: {
        // when window width is >= 769px
        769: {
            slidesPerView: postsSliderLoop ? 3 : "auto",
            spaceBetween: 32,
        },
    },
});

const imageSlider = new Swiper(".c-img-slider-block__swiper", {
    autoHeight: true,
    loop: true,
    watchSlidesVisibility: true,
    slidesPerView: 1,
    effect: "fade",
    fadeEffect: {
        crossFade: true,
    },

    // If we need pagination
    pagination: {
        el: ".c-img-slider-block__swiper-pagination",
        clickable: true,
    },

    // Navigation arrows
    navigation: {
        nextEl: ".c-img-slider-block__swiper-next",
        prevEl: ".c-img-slider-block__swiper-prev",
    },
});
const imageSliderCaption = new Swiper(".c-img-slider-block__swiper-caption", {
    autoHeight: true,
    loop: true,
    watchSlidesVisibility: true,
    slidesPerView: 1,
    effect: "fade",
    fadeEffect: {
        crossFade: true,
    },

    // If we need pagination
    pagination: {
        el: ".c-img-slider-block__swiper-pagination",
        clickable: true,
    },

    // Navigation arrows
    navigation: {
        nextEl: ".c-img-slider-block__swiper-next",
        prevEl: ".c-img-slider-block__swiper-prev",
    },
});

const carouselSlider = new Swiper(".c-masthead-carousel-block__swiper", {
    //false so that we can randomize slides first
    init: false,
    autoHeight: true,
    slidesPerView: 1,
    effect: "fade",
    allowTouchMove: false,
    preventClicks: false,
    fadeEffect: {
        crossFade: true,
    },
    autoplay: {
        delay: 7000,
    },
});

function shuffle(array) {
    let currentIndex = array.length,
        randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex != 0) {
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }

    return array;
}

function shuffleWithFeaturedFirst($children, featureFirst) {
    if (!featureFirst) {
        return shuffle($children.toArray());
    }

    // keep the first slide fixed, shuffle the rest
    const first = $children.first().toArray();
    const rest = $children.slice(1).toArray();
    return first.concat(shuffle(rest));
}

let resizeTimer;

function enablePostSlider(enabled) {
    /* If screensize is larger than 768 disable */
    if (!enabled) {
        postsSlider.disable();
    } else {
        postsSlider.enable();
    }
}

/** When window is load run functions */
(function ($) {
    const $block = $(".c-masthead-carousel-block"),
        $carousel = $(".c-masthead-carousel-block__inner"),
        $carouselChildren = $carousel.children(),
        featureSlide = $block.data("feature-slide") === true || $block.data("feature-slide") === "true",
        reordered = shuffleWithFeaturedFirst($carouselChildren, featureSlide);
    // If the flat slider, update delay timing
    if ($block.hasClass("c-masthead-carousel-block--flat")) {
        carouselSlider.params.autoplay.delay = 8000;
    }

    $carousel.empty().append(reordered).addClass("c-masthead-carousel-block__inner--show").parent(carouselSlider.init());

    $(window)
        .on("load", function () {
            /* set parameter of postslider so that it is enabled when screensize is less than 768 */
            enablePostSlider($(window).outerWidth() < 768);
        })
        .on("resize", function (e) {
            /** reset timer */
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                /* set parameter of postslider so that it is enabled when screensize is less than 768 */
                enablePostSlider($(window).outerWidth() < 768);
            }, 250);
        });
})(jQuery);
